import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Event } from 'src/app/core/models/event.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { EventService } from 'src/app/core/services/event.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-event-property',
  templateUrl: './event-property.component.html',
  styleUrls: ['./event-property.component.scss']
})
export class EventPropertyComponent implements OnInit {
  eventProperties = [];
  eventId = '';

  event = new Event();
  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private eventService: EventService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    if (this.route.snapshot.params.id) {
      this.eventId = this.route.snapshot.params.id;
      this.getEventProperties(this.eventId);
      this.getEvent(this.eventId);
    }
  }

  getEventProperties(id: string){
    this.eventService.getEventProperties(id).subscribe(response => {
      if (response.success) {
        this.eventProperties = response.eventProperties;
      }
      else {
        this.alertService.alert('Hata!', 'Etkinlik rolleri alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  getEvent(id: string) {
    this.eventService.getEventById(id).subscribe(response => {
      if (response.success) {
        this.event = response;
      }
      else {
        this.alertService.alert('Hata!', 'Etkinlik alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  deleteEventProperty(id: string, name: string) {
    const x = confirm(name + ' isimli etkinlik rolünü silmek istediğinize emin misiniz?');
    if (x) {
      this.eventService.deleteEventProperty(id).subscribe(response => {
        if (response.success) {
          this.getEventProperties(this.eventId);
          this.alertService.alert("Başarılı!", "Etkinlik rolü silindi!", "success");
        } else {
          this.alertService.alert("Hata!", "Etkinlik rolü silinemedi!", "error");
        }
      })
    }
  }

}
